const PTO_STATUS = Object.freeze({
    DRAFTED: 1,
    SUBMITTED: 2
});
const SFTO_STATUS = Object.freeze({
    DRAFTED: 7,
    SUBMITTED: 8
});

const FTO_STATUS = Object.freeze({
    DRAFTED: 3,
    SUBMITTED: 4
});

const REVISION_STATUS = Object.freeze({
    SUBMITTED: 1,
    RESOLVED: 2
});


export default Object.freeze({
    PTO: PTO_STATUS,
    SFTO: SFTO_STATUS,
    FTO: FTO_STATUS,
    REVISION: REVISION_STATUS,
    isPTO: (statusId) => Object.values(PTO_STATUS).includes(statusId),
    isFTO: (statusId) => Object.values(FTO_STATUS).includes(statusId),
    isSFTO: (statusId) => Object.values(SFTO_STATUS).includes(statusId),
});